/* Shreya — related products: loads recommendations for the current product when the section nears the viewport. */
(() => {
  if (customElements.get('related-products')) return;

  class RelatedProducts extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.section');
      if (this.hasAttribute('data-loaded') || !this.dataset.url) return;
      if (!('IntersectionObserver' in window)) { this.load(); return; }
      this.observer = new IntersectionObserver((entries) => {
        if (!entries.some((e) => e.isIntersecting)) return;
        this.observer.disconnect();
        this.load();
      }, { rootMargin: '0px 0px 400px 0px' });
      this.observer.observe(this.section || this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    async load() {
      try {
        const res = await fetch(this.dataset.url);
        if (!res.ok) throw new Error(res.statusText);
        const doc = window.Theme.parseHTML(await res.text());
        const fresh = doc.querySelector('related-products');
        const hasCards = fresh && fresh.querySelector('[data-slider-track] > li');
        if (!hasCards) { this.hideSection(); return; }
        this.innerHTML = fresh.innerHTML;
        this.setAttribute('data-loaded', '');
        if (this.section) this.section.classList.remove('is-pending');
        window.Theme.init(this);
      } catch (_) {
        this.hideSection();
      }
    }

    hideSection() {
      if (this.section) this.section.hidden = true;
    }
  }

  customElements.define('related-products', RelatedProducts);
})();
